import { Box, Divider } from '@mui/material';
import FormikAutoValidate from 'Components/Forms/FormikAutoValidate';
import {
  addressSchema,
  companySchemaCombined,
} from 'FeatureModules/Setting/schemas/company.schema';
import { Form, Formik } from 'formik';
import React, { FC, ReactNode } from 'react';
import { stripValuesToSchema } from 'utils/form.utils';
import AddressFields from './AddressFields';
import CompanyFields from './CompanyFields';
import { ICompany } from 'FeatureModules/Auth/types/company.types';

interface ICompanyFormCombinedProps {
  company: ICompany;
  children?: (props: { isSubmitting: boolean; values: ICompany }) => ReactNode;
  onSubmit: (values: ICompany) => void;
}

const CompanyFormCombined: FC<ICompanyFormCombinedProps> = ({ company, children, onSubmit }) => {
  const handleOnSubmit = async (values: ICompany) => {
    const strippedValues = stripValuesToSchema(values, companySchemaCombined);
    await onSubmit(strippedValues);
  };

  const initialValues: ICompany = {
    ...company,
    address: {
      ...addressSchema.default(),
      ...company.address,
    },
  };

  return (
    <Formik<ICompany>
      initialValues={initialValues}
      validationSchema={companySchemaCombined}
      validateOnBlur={false}
      validateOnChange={true}
      onSubmit={handleOnSubmit}
    >
      {({ isSubmitting, values }) => (
        <Form>
          <CompanyFields />
          <Box pt={2} pb={2}>
            <Divider />
          </Box>
          <AddressFields fullWidth accessor="address." />
          <FormikAutoValidate showValidation />
          {children &&
            children({
              isSubmitting,
              values,
            })}
        </Form>
      )}
    </Formik>
  );
};

export default CompanyFormCombined;
